var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$route.meta.noHeader&&_vm.title)?_c('div',{staticClass:"flex_start main back"},[_c('div',{staticClass:"flex_start back-left",on:{"click":function($event){return _vm.$router.back()}}},[_c('img',{attrs:{"src":_vm.basic_static+'learnspace/images/back.png'}}),_c('p',[_vm._v("返回")])]),_c('p',[_vm._v("/"+_vm._s(_vm.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }